import Component from './Component';

export default class SupportVideo extends Component {
  load() {
    this.initSupportVideo();

    super.load();
  }

  initSupportVideo() {

    let loadVideo = false;
    const hostedVideoElement = document.getElementById('vimeobgplayer') || document.getElementById('youtubebanner');
    const ourVideos = document.querySelectorAll('#ourvideo source');
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    if (hostedVideoElement || ourVideos) {



      // Detect if desktop or mobile

      // load video banner only on fast & wide desktop
      loadVideo = (isFastNetwork(connection) && !likelyMobileScreen() && !hasOrientation());
      // console.log('loadVideo: ', loadVideo);


      // load video banner
      if (hostedVideoElement && loadVideo) {
        // console.log('load HOSTED Video');
        if (hostedVideoElement.src < 5) {  // only overwrite if too short to be valid
          hostedVideoElement.src = hostedVideoElement.dataset.src;
        }
        showVideoElement();
      } else if (ourVideos && loadVideo) {
        // console.log('load OUR Video');
        ourVideos.forEach(element => {
          if (element.src.length < 5) {  // only overwrite if too short to be valid
            element.src = element.dataset.src;
          }
        });
        showVideoElement();
      } else {
        console.log('no banner video');
      }



    }

  }
}

function isFastNetwork(connection) {
  if (connection) {
    return /4g/i.test(connection.effectiveType);  // Network speed (only supported in Chromium browsers)
  } else {
    console.log('network API is not supported.');
  }
}

// Removed User-Agent check, as support is reduced.
// function isDesktopOS() {
//   return /Win|Mac|Arch/i.test(navigator.userAgent);  // Agent String
// }

function likelyMobileScreen() {  //or small view  //screen.width  // window.devicePixelRatio > 1.74 &&
  return (window.innerWidth < 768); // (window.innerWidth < 1079)
}

function hasOrientation() {
  return (window.orientation === 'undefined'); // desktop's unlikely to have orientation defined
}

function showVideoElement() {
  const vidBackgroundElement = document.querySelector('.banner__container > .video-background');
  if (vidBackgroundElement) {
    vidBackgroundElement.classList.remove('hideme');
  }
}
